import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { toasterMsg } from '../Components/Toaster/Toaster';
import { localStorageService } from './localStorage.service';

export const getAllUsageProductList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_ATTRIBUTES.GET_ALL_USAGE_PRODUCTS}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};

export const getAllFactoriesList = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PRODUCT_ATTRIBUTES.GET_ALL_FACTORY_SUPPLIERS}`, {
      params: { ...data },
    });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};

export const AddUsageProduct = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PRODUCT_ATTRIBUTES.GET_ALL_USAGE_PRODUCTS}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};

export const updateUsageProduct = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PRODUCT_ATTRIBUTES.GET_ALL_USAGE_PRODUCTS}`, { ...data });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};

export const deleteUsageProduct = async (deldata) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PRODUCT_ATTRIBUTES.GET_ALL_USAGE_PRODUCTS}`, { data: { ...deldata } });
  } catch (error) {
    toasterMsg(`${error}`, 'danger');
  }
};

/**
 * Requests the BOM usage spreadsheet.
 * Failures are read from two places: the endpoint answers a 4xx/5xx that axios rejects, and it can also
 * answer a JSON body under HTTP 200, which axios resolves like a success. Without the content-type check
 * that second case would be wrapped in a spreadsheet-typed Blob and saved as a corrupt .xlsx.
 * @param {object} data Export parameters (bom ids, filters, companyURL).
 * @returns {Promise<Blob|{errMsg: string}|boolean>} Blob on success, an object holding errMsg (empty when
 * the body could not be read) when the server reported a failure, or true when there is no logged-in user.
 */
export const exportBOMUsageDetails = async (data) => {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.PRODUCT_ATTRIBUTES.DOWNLOAD_BOM_USAGE}`, data, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function err(error) {
            reject(error);
          });
      });
    }
    return true;
  }
